// client/src/pages/Analytics.jsx

import React, { useEffect, useState } from 'react';
import { isAuthenticated } from '../index';
import styles from '../App.module.css';
import { FaPencilAlt } from 'react-icons/fa';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { nomeVendedor } from '../components/equipeagiliza';
import api from '../api/axios';

function Analytics() {
    const { userNome } = isAuthenticated();
    const [financasAgiliza, setFinancasAgiliza] = useState([]);
    const [servicos, setServicos] = useState([]);
    async function getUsers() {
        try {
            const resFinancasAgiliza = await api.get('/FinancasAgiliza');
            const response = await api.get('/servicos');
            setServicos(response.data);
            setFinancasAgiliza(resFinancasAgiliza.data);
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
            NotificationManager.error('Erro ao buscar usuários.', 'Erro');
        }
    }
    useEffect(() => {
        getUsers();
    }, []);
    const getServiceNameByIndex = (index) => {
        const service = servicos.find(servico => servico.index === parseInt(index));
        return service ? service.nome : 'Serviço desconhecido';
    };
    const renderBubbles = (servicos) => {
        try {
            const parsedServices = JSON.parse(servicos);
            return parsedServices.map((service, idx) => (
                <div key={idx} className={styles.bubble}>
                    <p className={styles.bubbleText}>({service.quantidade}) {getServiceNameByIndex(service.index)}</p>
                </div>
            ));
        } catch (error) {
            console.error('Erro ao renderizar bolhas de serviço:', error);
            return <p>Erro ao carregar serviços</p>;
        }
    };
    const categories = [
        { name: 'Venda total', color: '#B2FFD1', link: '/produzir', icon: <FaPencilAlt size={20} color="#333" /> },
        { name: 'Quantidade', color: '#FFB2B2', link: '/monitorar', icon: <FaPencilAlt size={20} color="#333" /> },
        { name: 'Serviços', color: '#fff', link: '/analise', icon: <FaPencilAlt size={20} color="#333" /> },
        { name: 'Clientes novos', color: '#B2D6FF', link: '/producao', icon: <FaPencilAlt size={20} color="#333" /> },
    ];
    return (
        <div className={styles.app}>
            <NotificationContainer />
            <div style={{ width: "100%", backgroundColor: "blue", color: "white" }}>
                {userNome ? `Olá, ${userNome}` : "Faça o login em sua conta para acessar as funcionalidades"}
            </div>
            <div style={{ width: "100%", maxWidth: "600px" }}>
                <div className={styles.categoriesContainer}>
                    {categories.map((category, index) => (
                        <div key={index} className={styles.categoryItem} style={{
                            backgroundColor: category.color,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "15px",
                            textDecoration: "none",
                            color: "black",
                            fontWeight: "600",
                            textAlign: "center"
                        }}>
                            <span>{category.icon}</span>
                            <h1>50000</h1>
                            <p>{category.name}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className={`${styles.corTitulo} ${styles.bluea}`}>
                <p className={styles.titulo}>VENDAS</p>
            </div>
            <div className={styles.cadastroClienteContainer}>
                <div className={styles.tituloContainer}></div>
                <div className={styles.divisor}></div>
                <div className={styles.usersListContainer}>
                    {financasAgiliza.map((user) => (
                        <div key={user.id} className={styles.userContainer} style={{ backgroundColor: 'var(--corPrimaria)', color: 'white' }}>
                            <div style={{ width: '100%', display: 'flex' }}>
                                <div style={{ width: '50%' }}>
                                    <p style={{ fontSize: '1rem', fontWeight: '600' }}>{user.clienteNome}</p>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <p className={styles.loginContainer2} style={{ fontSize: '1rem', textAlign: 'end' }}>{user.valor}.00R$</p>
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex' }}>
                                <div style={{ width: '50%' }}>
                                    <p>{user.clienteContato}</p>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <p className={styles.loginContainer2} style={{ textAlign: 'end' }}>
                                        {nomeVendedor.find(vendedor => vendedor.value === user.vendedor)?.nome || 'Desconhecido'}
                                    </p>
                                </div>
                            </div>
                            <div style={{ display: 'block', width: '100%' }}>
                                <div className={styles.servicos}>
                                    {renderBubbles(user.servicos)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Analytics;
